module.exports = __webpack_public_path__ + "img/avatar.9873fd7f.png";